import EmailTemplateModes from 'EmailData/enums/EmailTemplateModes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { getIsUngatedForPublishDateForBatchEmailPinotStats } from 'email-management-lib/refactor/selectors/user';
import { getPerformanceRedirectParams } from 'email-management-lib/refactor/utils/performance/params';
import { trySetEarlyPreviewCacheValue } from 'messaging-editing-lib/hooks/useEarlyPreviewCache';
import { useInsightContext } from 'messaging-publishing-lib/Insights/components/InsightContextProviderBase';
import { EMAIL_TYPE } from 'messaging-types-lib/content/contentEmail';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
function editUrl(emailId) {
  return `/email/${PortalIdParser.get()}/edit/${emailId}/content`;
}
function detailsUrl(emailObject, params = '') {
  const emailId = emailObject.id;
  const portalId = PortalIdParser.get();
  const isActiveABEmail = emailObject.isPublished() && emailObject.isABLike();
  const _params = params ? `?${params}` : '';
  return `/email/${portalId}/details/${emailId}/${isActiveABEmail ? 'ab-test' : 'performance'}${_params}`;
}
function EmailLinkWithTooltip({
  canCreateClassicEmail,
  emailObject,
  emailTypesAuthedFor
}) {
  const emailName = emailObject.name;
  const emailId = emailObject.id;
  const isDraft = emailObject.isDraft();
  const isErrored = emailObject.isErrored();
  const isClassicTemplateEmail = emailObject.emailTemplateMode === EmailTemplateModes.DESIGN_MANAGER;
  const insightContext = useInsightContext();
  const isUngatedForPublishDateForBatchEmailPinotStats = useSelector(getIsUngatedForPublishDateForBatchEmailPinotStats);
  const performanceRedirectParams = getPerformanceRedirectParams({
    crmEmail: emailObject,
    insightContext,
    isUngatedForPublishDateForBatchEmailPinotStats
  });
  const linkDisabled = isDraft && (isClassicTemplateEmail && !canCreateClassicEmail || emailObject.isABEmail() && emailTypesAuthedFor.indexOf(EMAIL_TYPE.AB_EMAIL) < 0 || emailObject.isABAutomatedEmail() && emailTypesAuthedFor.indexOf(EMAIL_TYPE.AUTOMATED_AB_EMAIL) < 0 || emailObject.isAutomated() && emailTypesAuthedFor.indexOf(EMAIL_TYPE.AUTOMATED_EMAIL) < 0 && !emailObject.isLeadFlowEmail() || emailObject.isBlogEmail() && emailTypesAuthedFor.indexOf(EMAIL_TYPE.BLOG_EMAIL) < 0 || emailObject.isRssEmail() && emailTypesAuthedFor.indexOf(EMAIL_TYPE.RSS_EMAIL) < 0);
  const shouldLinkToEditor = isDraft && !isErrored;
  const href = shouldLinkToEditor ? editUrl(emailId) : detailsUrl(emailObject, performanceRedirectParams);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !linkDisabled,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email-management.table.disabledForUpgrade"
    }),
    children: /*#__PURE__*/_jsx(Link, {
      "data-test-id": "title-cell-link",
      disabled: linkDisabled,
      href: href,
      onClick: event => event.stopPropagation(),
      onMouseDown: () => {
        if (shouldLinkToEditor && !linkDisabled) {
          trySetEarlyPreviewCacheValue(emailObject);
        }
      },
      children: /*#__PURE__*/_jsx(BreakString, {
        children: emailName
      })
    })
  });
}
export default EmailLinkWithTooltip;